module.exports = __webpack_public_path__ + "img/header-weddingRingsTwoColors@2x.8fda76c.webp";